import { useState } from "react"

import { Heading, Icon, Tappable } from "@trueskin-web/components"
import { minusIcon } from "@trueskin-web/theme/icons/minusIcon"
import { plusIcon } from "@trueskin-web/theme/icons/plusIcon"

const Accordion = ({ icon, title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div
      sx={{
        mb: 2,
        py: 2,
        "&:not(:last-of-type)": {
          borderBottom: "1px",
          borderColor: "grey",
        },
      }}
    >
      <Tappable
        sx={{
          display: "grid",
          gridTemplateColumns: "auto 1fr auto",
          width: "100%",
          pb: 2,
        }}
        onClick={() => setIsExpanded((value) => !value)}
      >
        {icon && <Icon icon={icon} sx={{ mr: 2 }} />}
        <Heading
          as="h3"
          sx={{
            mr: 6,
            fontSize: 2,
            lineHeight: "1.3",
            textAlign: "left",
            whiteSpace: "normal",
            flex: 1,
          }}
        >
          {title}
        </Heading>
        <Icon
          icon={isExpanded ? minusIcon : plusIcon}
          size="sm"
          sx={{
            ml: "auto",
          }}
        />
      </Tappable>
      <div
        sx={{
          display: isExpanded ? "block" : "none",
          mb: 2,
          fontSize: 1,
          lineHeight: "body",
          px: 4,
          variant: "vwo.colors.textLight",
          "& p:first-of-type": { mt: 0 },
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default Accordion
